module.exports = __webpack_public_path__ + "img/subscribe.e72265cf.png";